<template>
  <!-- 回收站 author: zhangxiaofeng-->
  <div class="recycle-bin" :class="{'space-enterprise': forSpaceEnterprise}" id="recycle-bin">
    <!-- 顶部操作区域 -->
    <div class="content--options" id="recycle-bin--options" :style="{paddingRight: forSpaceEnterprise?0:''}">
      <div class="list">
        <!-- 列表/缩略图 切换 -->
        <!-- 按钮组 -->
        <operation-buttons
          :button-list="buttonList"
          @clickHandle="topButtonClick"
          class="float_left"
        ></operation-buttons>
        <operation-module-type
          @change="queryConditionChange"
          :current-sort="currentSort"
          :sort-filed-names="sortFiledNames"
          :selected-type="queryCondition.moduleType"
          class="float_right"
        ></operation-module-type>
        <!-- 搜索 -->
        <operation-search class="float_right margin-left-10 " placeholder="输入关键字搜索" @onSearch="searchHandle"></operation-search>
        <!-- 文件类型筛选 checked="amountFile" -->
        <!--<operation-file-type-->
          <!--@change="queryConditionChange"-->
          <!--class="float_right"-->
          <!--v-if="!forSpaceEnterprise"-->
        <!--&gt;</operation-file-type>-->
      </div>
    </div>
    <div class="table-wrapper" >
      <div class="tabcnt" ref="tableContent">
        <template>
          <!-- 列表形式 -->
          <simple-table
            v-if="tableHeight && queryCondition.moduleType === 'list'"
            :height="tableHeight"
            :showNoData="dataList.length === 0"
            v-loading="loading"
            :type="2" no-data-text="暂无数据"
            element-loading-background="rgba(255, 255, 255, 0.8)">
            <thead slot="header">
              <tr :key="currentSort">
                <th width="300" class="checkAllth">
                  <label class="checkall-label">
                    <!--<input type="checkbox" @click="checkAll" :checked="isCheckAll" /> 全选-->
                    <w-checkbox @change="checkAll" v-model="isCheckAll"></w-checkbox>
                  </label>
                  <!--<span class="check-length">-->
                    <!--<span v-if="select.total > 0">已选中{{select.total}}个文件/文件夹</span>-->
                  <!--</span>-->
                  <span class="person-sort" @click="changeSort('name_chn')">
                    名称
                    <i :class="currentSort | computeSortClass(queryCondition, 'name_chn')"></i>
                  </span>
                </th>
                <!--<th width="120" v-if="tabletype !== 'companyList'">类型</th>-->
                <!--<th width="60" v-if="tabletype !== 'companyList'">地区</th>-->
                <th width="120" v-if="user.role === 2">
                  创建人
                  <!--{{tabletype === 'companyList' ? '上传者' : '编制人'}}-->
                </th>
                <th width="80">
                    <span class="person-sort" @click="changeSort('modifiedTime')">
                      {{forSpaceEnterprise ? '删除时间' : '修改时间'}}
                      <i :class="currentSort | computeSortClass(queryCondition, 'modifiedTime')"></i>
                    </span>
                </th>
                <th width="80">{{forSpaceEnterprise ? '删除人' : tabletype === 'companyList' ? '上传时间' : '创建时间'}}</th>
                <th width="80">
                  <span class="person-sort" @click="changeSort('size')">
                    文件大小
                    <i :class="currentSort | computeSortClass(queryCondition, 'size')"></i>
                  </span>
                </th>
                <th width="100" class="is-operate"></th>
              </tr>
            </thead>
            <tbody slot="body">
              <tr
              v-for="(item,index) in dataList"
              :key="'tr_data_' + index"
              height="40"
              :class="item.checked ? 'active trItem' : 'trItem'"
              @click="trClick(index, $event)"
              @mouseenter="trMouseEnter(item)"
              @mouseleave="trMouseLeave(item)"
            >
              <td width="300">
                <div class="l-boxd bin-table-name">
                  <!--<input-->
                  <!--type="checkbox"-->
                  <!--:checked="item.checked"-->
                  <!--@click.stop="checkOne(item, index)"-->
                  <!--/>-->
                  <w-checkbox v-model="item.checked" @change="checkOne(item, index)" style="margin-right: 0;"></w-checkbox>
                  <div class="personHover l-boxd-d">
                    <template v-if="item && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                      <i
                        :class="['file-icons', 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex = -1"
                        @click.stop="nameClick(item)"
                      ></i>
                    </template>
                    <template v-else-if="item.thumbnailUrl && +queryCondition.fileType === 2">
                      <img
                        :src="item.thumbnailUrl"
                        @mouseenter="personTextBoxStyleHandle(index)"
                        @mouseleave="iconHoverIndex = -1"
                      />
                    </template>
                    <template v-else>
                      <i
                        :class="['file-icons', item&&item.suffix&&(item.suffix+'').toUpperCase() === 'GTJXT'? 'icon_' : 'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? 'folder': '']"
                        @mouseenter="personTextBoxStyleHandle(index)"
                        @mouseleave="iconHoverIndex = -1"
                      ></i>
                    </template>
                    <span class="recycle-file-name" :title="item.name">{{item.name}}</span>
                    <w-tag style="color: rgba(33,37,48,0.55);border-color: rgba(222,223,224,1);" class="margin-left-10" size="mini" around v-if="item.fileType == 1 && item.fileProperties.region">{{item.fileProperties.region}}</w-tag>
                  </div>
                  <div
                    v-if="!item.folder"
                    class="person-textbox"
                    v-show="iconHoverIndex === index"
                  >
                    <p>创建时间：{{item.createTime | formatDayFilter()}}</p>
                    <p>文件大小：{{item.length | formatSizeFilter()}}</p>
                    <template v-if="+item.fileType === 1">
                      <p>
                        文件类型：
                        <template v-if="+item.extraInfo === 1">概算</template>
                        <template v-else-if="+item.extraInfo === 2">预算</template>
                        <template v-else-if="+item.extraInfo === 3">结算</template>
                        <template v-else>审核</template>
                      </p>
                    </template>
                    <template v-if="+item.fileType === 2">
                      <p>
                        <label>工程类别：</label>
                        {{item.fileProperties.projectCategory || '【无】'}}
                      </p>
                      <p>
                        <label>结构类型：</label>
                        {{item.fileProperties.structureCategory || '【无】'}}
                      </p>
                      <p>
                        <label>清单规则：</label>
                        {{item.fileProperties.listRule || '【无】'}}
                      </p>
                      <p>
                        <label>定额规则：</label>
                        {{item.fileProperties.quotaRule || '【无】'}}
                      </p>
                    </template>
                  </div>
                </div>
              </td>
              <!--<td width="120" align="center" v-if="tabletype !== 'companyList'">{{item.fileType | formatFileTypeFilter()}}</td>-->
              <!--<td width="60" align="center" v-if="tabletype !== 'companyList'">{{item.fileProperties.region}}</td>-->
              <td
                width="120"
                class="font-left"
                :title="item.originalCreatorName"
                v-if="user.role === 2"
              >{{item.originalCreatorName}}</td>
              <td width="80">{{item.modifyTime | formatDayFilter()}}</td>
              <!-- 项目空间回收站 列 -->
              <td width="80" style="word-break: break-all; white-space: normal;" v-if="forSpaceEnterprise">{{item.modifierName}}</td>
              <!-- 回收站 列 -->
              <td width="80" v-else>{{item.createTime | formatDayFilter()}}</td>
              <td width="80" v-if="item.folder==true"></td>
              <td width="80" v-else>{{item.length | formatSizeFilter()}}</td>
              <td width="100"class="is-operate operation">
                <el-tooltip content="彻底删除">
                  <a
                    class="r2-icon-action_delete_outline"
                    @click.stop="dealItem([item], 'deleteThoroughly')"></a>
                </el-tooltip>
                <el-tooltip content="还原">
                  <a class="w-icon-huanyuan" @click.stop="dealItem([item], 'restore')"></a>
                </el-tooltip>
              </td>
            </tr>
              <!--<div v-if="dataList.length === 0" class="empty-box">-->
                <!--<img src="@/assets/images/default_empty.png" />-->
                <!--<p class="font-16">没有文件</p>-->
              <!--</div>-->
              <!--<template v-else></template>-->
            </tbody>
          </simple-table>
          <!-- 缩略图形式 -->
          <div
            v-if="tableHeight && queryCondition.moduleType === 'thumbnail'"
            class="listcnt table-body-wrapper size_96"
            :style="{height: tableHeight + 50 + 'px'}">
            <div class="imgItem-checkall">
              <label class="checkall-label">
                <!--<input type="checkbox" @click="checkAll" :checked="isCheckAll" /> 全选-->
                <w-checkbox @change="checkAll" v-model="isCheckAll">全选</w-checkbox>
              </label>
              <!--<span class="check-length">-->
                <!--<span v-if="select.total > 0">已选中{{select.total}}个文件/文件夹</span>-->
              <!--</span>-->
            </div>
            <div
              class="thumbnail-item relative"
              :class="item.checked ? 'active trItem imgItem' : 'trItem imgItem'"
              v-for="(item,index) in dataList"
              :key="index"
              @mouseenter="trMouseEnter(item,index)"
              @mouseleave="trMouseLeave(item)"
            >
              <div class="absolute more" style="right: 5px; top: 2px;z-index: 9;">
                <w-dropdown @command="handlerAction" trigger="click">
                  <span class="w__dropdown-link">
                     <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 16px !important;"></i></span>
                  </span>
                  <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                    <w-dropdown-item :disabled="!select.total" :command="{item, fn: 'dealItem', type: 'deleteThoroughly'}">彻底删除</w-dropdown-item>
                    <w-dropdown-item :disabled="!select.total" :command="{item, fn: 'dealItem', type: 'restore'}">还原</w-dropdown-item>
                  </w-dropdown-menu>
                </w-dropdown>
              </div>
              <!--<input-->
                <!--type="checkbox"-->
                <!--class="imgItem-checkbox"-->
                <!--:checked="item.checked"-->
                <!--@click.stop="checkOne(item, index)"-->
              <!--/>-->
              <w-checkbox class="imgItem-checkbox" v-model="item.checked" @change="checkOne(item, index)"></w-checkbox>
              <div class="imgItem-box">
                <template v-if="item && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                  <i
                    :class="['file-icons', 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  ></i>
                </template>
                <template v-else-if="item.thumbnailUrl">
                  <img
                    :src="item.thumbnailUrl"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                  />
                </template>
                <template v-else>
                  <i
                    :class="['file-icons',  'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? 'folder': '']"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                  ></i>
                </template>
                <div v-if="!item.folder" class="person-textbox" v-show="iconHoverIndex === index">
                  <p>创建时间：{{item.createTime | formatDayFilter()}}</p>
                  <p>文件大小：{{item.length | formatSizeFilter()}}</p>
                  <p>编制人：{{item.originalCreatorName}}</p>
                  <template v-if="+item.fileType === 1">
                    <p>
                      文件类型：
                      <template v-if="+item.extraInfo === 1">概算</template>
                      <template v-else-if="+item.extraInfo === 2">预算</template>
                      <template v-else-if="+item.extraInfo === 3">结算</template>
                      <template v-else>审核</template>
                    </p>
                  </template>
                  <template v-if="+item.fileType === 2">
                    <p>
                      <label>工程类别：</label>
                      {{item.fileProperties.projectCategory || '【无】'}}
                    </p>
                    <p>
                      <label>结构类型：</label>
                      {{item.fileProperties.structureCategory || '【无】'}}
                    </p>
                    <p>
                      <label>清单规则：</label>
                      {{item.fileProperties.listRule || '【无】'}}
                    </p>
                    <p>
                      <label>定额规则：</label>
                      {{item.fileProperties.quotaRule || '【无】'}}
                    </p>
                  </template>
                </div>
              </div>
              <div class="imgItem-name">
                <!--  v-on:click.stop="nameClick(item)"  -->
                <a class="imgItem-name-a">{{item.name}}</a>
              </div>
              <div class="imgItem-filetime">{{item.modifyTime | formatDayFilter()}}</div>
            </div>
          </div>
        </template>
      </div>

      <div class="mydrag-sel" v-if="mydragSelShow"></div>
      <div class="mydrag-icon" v-show="mydragIconShow"></div>
      <ul class="contextMenu" v-show="contextMenuShow">
        <li :class="{disable: !select.total}" @click="dealItem([], 'deleteThoroughly', true)">彻底删除</li>
        <li :class="{disable: !select.total}" @click="dealItem([], 'restore', true)">还原</li>
      </ul>
    </div>
    <verify-code  @dialogVisibleEvent='showVerify=false' :showVerify="showVerify"></verify-code>
  </div>
</template>
<script>
import {
  OperationButtons,
  OperationFileType,
  OperationModuleType,
  OperationSearch,
  SimpleTable
} from '@/components/common'
import _ from 'lodash'
import * as domEvent from '@zjy/zjy-ui/lib/utils/dom'
import { throttle } from 'throttle-debounce'
import service from '@/assets/service'
import { mapState } from 'vuex'
import VerifyCode from '@/components/VerifyCode'
import { getCookie } from '@/assets/utils/CommonUtil'
import SpaceService from '@/assets/service/space'
import LoginService from '@/assets/service/login'
export default {
  name: 'RecycleBin',
  props: {
    forSpaceEnterprise: {
      // 是否为 项目空间回收站
      type: Boolean,
      default: true
    },
    tabletype: {
      type: String,
      default: ''
    }
  },
  data () {
    // let isAdmin = false
    // if (getCookie('role') && +getCookie('role') === 2) {
    //   isAdmin = true
    // }
    return {
      showVerify: false,
      isAdmin: false,
      buttonList: ['restore', 'deleteThoroughly', 'clear', 'refresh'],
      // 查询条件
      queryCondition: {
        sortFieldName: 'modifiedTime', // 排序字段,可用值:modifiedTime,name_chn,size
        sortType: 1, // 排序类型，0:升序,1:降序
        // workspaceId: this.workspaceId,
        moduleType: 'list', // 列表形式 list: 列表， thumbnail: 缩略图
        fileType: 0, // 文件类型
        isPaginated: false // 是否分页
      },
      sortFiledNames: [
        // 排序字段列表
        { key: 'name_chn', name: '工程名称', sortType: -1 },
        { key: 'modifiedTime', name: '修改时间', sortType: -1 },
        { key: 'size', name: '文件大小', sortType: -1 }
      ],
      currentSort: 'modifiedTime,1', // 当前的排序方式
      select: {
        total: 0, // 已选择文件总数
        files: '' // 已选择文件列表
      },
      loading: false,
      dataList: [], // 表格数据
      isCheckAll: false,
      contextMenuShow: false, // 右键
      mydragSelShow: false, // 是否显示框选框
      mydragIconShow: false, // 是否显示拖拽图标
      eventObj: {
        shift: false, // 是否 按着 Shift 键 isOnShift
        ctrl: false, // 是否 按着 Ctrl 键 isOnCtrl
        mouse: {},
        mouseInTr: false, // 鼠标是否 悬停在某一行数据上 trIsMouseEnter
        trFocusIndex: -1, // 鼠标悬停在 第几行 默认 -1 未悬停在任意一行数据上 mouserEnterItemIndex
        mousedownInSelectTr: false, // 鼠标是否在 已选择的某一行中 按下 isDownSel
        mousedown: false, // 鼠标是否 按下 isDown
        startX: 0, // 鼠标移动 开始位置的 X 坐标 startX
        startY: 0, // 鼠标移动 开始位置的 Y 坐标 startY
        isAddBox: false, // isAddBox
        clickIndex: -1, // clickIndex
        keydownEvent: null,
        keyupEvent: null,
        mousedownEvent: null,
        mousemoveEvent: null,
        mouseupEvent: null
      },
      user: {},
      iconHoverIndex: -1
    }
  },
  computed: {
    ...mapState({
      userInfoReady: state => state.user.userInfoReady,
      workspace: state => state.space.workspace,
      workspaceReady: state => state.space.workspaceReady,
      prjRole: state => state.project.role
    }),
    urlParams () {
      return this.$route.params || {}
    },
    // 空间ID
    workspaceId () {
      let workspaceId = ''
      if (this.forSpaceEnterprise) {
        // 项目空间回收站
        workspaceId = this.workspace[3] || ''
      } else {
        if (this.tabletype === 'companyList') {
          // 共享空间
          workspaceId = this.workspace[2] || ''
        } else {
          workspaceId = this.workspace[1] || ''
        }
        // // 回收站
        // if (+this.user.userType === 1) {
        //   // 管理员 企业共享空间
        //   workspaceId = this.workspace[2] || ''
        // } else {
        //   // 普通员工 企业员工空间； 普通用户 个人空间
        //   workspaceId = this.workspace[1] || ''
        // }
      }
      return workspaceId
    }
  },
  filters: {
    // 计算排序列 icon 显示 的class
    computeSortClass (currentSort, queryCondition, key) {
      let cls = 'sort '
      if (
        queryCondition['sortFieldName'] === key &&
        'sortType' in queryCondition
      ) {
        switch (+queryCondition.sortType) {
          case 0:
            cls += 'sort-up'
            break
          case 1:
            cls += 'sort-down'
            break
          default:
            cls += ''
        }
      }
      return cls
    }
  },
  beforeDestroy () {
    this.destroyEvent()
  },
  created () {
    console.log('*************prjRole*********', this.prjRole)
    this.isAdmin = this.hasModuleAuth('zjy_module_project_zsxmk_wcyd_manage') || this.hasModuleAuth('zjy_module_project_zsxmk_qbxm_manage')
    if (this.prjRole === 4){
      this.buttonList = ['refresh']
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    // let otherHeight = 45 + 55 + 52 + 50
    // if (this.forSpaceEnterprise) {
    //   otherHeight += 120
    // }
    // this.setTableHeight(otherHeight)
    setTimeout(() => {
      this.tableHeight = this.getTableHeight('recycle-bin') - this.getTableHeight('recycle-bin--options') - 75
    }, 200)
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      // this.setTableHeight(otherHeight)
      this.tableHeight = this.getTableHeight('recycle-bin') - this.getTableHeight('recycle-bin--options') - 75
    })
    this.initEvent()
    this.queryList()
  },
  methods: {
    handlerAction ({item, fn, type}) {
      this[fn]([], type)
    },
    // 图标hover
    personTextBoxStyleHandle (index) {
      handelTextBoxStyle(this)
      this.iconHoverIndex = index
    },
    // 1. 搜索
    searchHandle: _.debounce(function (name){
      this.$set(this.queryCondition, 'fileName', name)
      this.queryList()
      // this.sendLogByDic('搜索', logDic, dicIndex, this.tabletype, 'search')
      // this.searchVal=obj.target.value
      // initData(this)
    }, 800),
    // searchHandle(name) {
    //   // 埋点-搜索
    // },
    // 1.1 查询条件改变时
    queryConditionChange (obj) {
      // 设置查询条件
      for (const key in obj) {
        this.$set(this.queryCondition, key, obj[key])
      }
      if ('sortFieldName' in obj) {
        // 排序方式 切换
        // console.log('按排序: ' + obj.sortFieldName)
        // console.log('排序方式【0:升序,1:降序】: ' + obj.sortType)
        this.currentSort = obj.sortFieldName + ',' + obj.sortType
      }
      if ('moduleType' in obj) {
        // 缩略图/列表 切换
        // console.log('缩略图/列表: ' + obj.moduleType)
        // this.$nextTick(() => {
        //   this.initEvent()
        // })
      }
      this.queryList()
    },
    // 1.2  表头 排序切换
    changeSort (key) {
      // 埋点
      if (key === 'name_chn') {
        this.sentLog(100114018, {page: 2, type: this.queryCondition.sortFieldName === key ? +this.queryCondition.sortType === 0 ? 2 : 1 : 1})
      } else if (key === 'modifiedTime') {
        this.sentLog(100114017, {page: 2, type: this.queryCondition.sortFieldName === key ? +this.queryCondition.sortType === 0 ? 2 : 1 : 1})
      } else {
        this.sentLog(100114016, {page: 2, type: this.queryCondition.sortFieldName === key ? +this.queryCondition.sortType === 0 ? 2 : 1 : 1})
      }

      let sortType = 0
      if (this.queryCondition.sortFieldName !== key) {
        this.$set(this.queryCondition, 'sortFieldName', key)
      } else {
        sortType = (+this.queryCondition.sortType + 1) % 2
      }
      this.$set(this.queryCondition, 'sortType', sortType)
      this.currentSort = key + ',' + sortType
      this.queryList()
    },
    // 处理文件类型
    getFileTypeHandle (proT) {
      let extraInfo, extraInfoStr
      if (proT >= 4000) {
        extraInfo = 4
        extraInfoStr = '审核'
      } else if (proT >= 3000) {
        extraInfo = 3
        extraInfoStr = '结算'
      } else if (proT >= 2000) {
        extraInfo = 2
        extraInfoStr = '预算'
      } else if (proT >= 1000) {
        extraInfo = 1
        extraInfoStr = '概算'
      } else {
        extraInfo = 0
        extraInfoStr = '其它'
      }
      return {
        extraInfo,
        extraInfoStr
      }
    },
    // 1.3 查询数据
    queryList () {
      if (!this.userInfoReady || !this.workspaceReady) return
      const params = Object.assign(this.queryCondition, {
        workspaceId: this.workspaceId
      })
      if (this.forSpaceEnterprise) {
        params.projectId = this.urlParams.id
      }
      this.select.total = 0
      this.select.files = []
      this.dataList = []
      this.isCheckAll = false
      this.loading = true
      service.recycleBin.getRecycleList(params).then(data => {
        this.loading = false
        if (+data.code === 200) {
          let list = data.data || []
          list.forEach(item => {
            item.checked = false
            if (
              +item.fileType === 1 &&
              item.fileProperties &&
              item.fileProperties.projectType
            ) {
              item.extraInfo = this.getFileTypeHandle(
                item.fileProperties.projectType
              ).extraInfo
            }
          })
          // if (!list.length) {
          //   list = clone(require('assets/js/testData/recycle').default.list)
          // }
          this.dataList = list.filter(item => {
            if (this.queryCondition.fileName !== '') {
              // 通过搜索框的值 过滤查询结果
              const reg = new RegExp(this.queryCondition.fileName)
              return reg.test(item.name)
            } else {
              return true
            }
          })
        } else {
          this.$message.error('获取数据失败')
        }
        // console.log(this.dataList)
      }).catch(() => {
        this.loading = false
      })
    },
    // 2. 顶部其他按钮点击
    async topButtonClick (type, e) {
      const dealData = {}
      if (this.forSpaceEnterprise) {
        dealData.projectId = this.urlParams.id
      } else {
        dealData.workspaceId = this.workspaceId
      }
      switch (type) {
        case 'deleteThoroughly':
          this.dealItem([], 'deleteThoroughly', false, true)
          break
        case 'restore':
          this.dealItem([], 'restore', false, true)
          break
        case 'refresh':
          this.queryList()
          if (this.tabletype === 'companyList') {
            this.sentLog(100114015)
          }
          break
        case 'clear':
          // 项目回收站
          // 埋点-清空回收站

          if (this.forSpaceEnterprise) {
            this.sentLog(100112053)
          } else if (this.tabletype === 'companyList') {
            this.sentLog(100114014)
          } else {
            this.sentLog(100113031)
          }
          if (
            this.forSpaceEnterprise && this.prjRole !== 1 && !this.isAdmin
          ) {
            this.$message.warning('无清空回收站权限！请联系项目创建人!')
            return
          }
          // if (this.tabletype !== 'projectList'){
          //   let flag = await this.isDoubleVerify()
          //   if (flag) {
          //     return false
          //   }
          // }
          if (!this.dataList.length) {
            this.$message.info('没有可清空的文件')
          } else {
            this.$confirm({
              message: '确定要清空回收站？', // 提示主文案
              type: 'warning', //  可不传 提示框类型 primary: 按钮、icon 为蓝色（默认）; warning: 按钮、icon 为橙色
              tips: '清空回收站后，不能恢复。', // 提示文案（第二行小字体）
              // tipsRed: '', // 提示文案（第二行小字体 橙色）
              dealData: dealData, // 需要操作的数据 submit回调 返回用
              submit: params => {
                // 操作记录
                this.addOperationRecords(
                  4,
                  {},
                  { page: 'recycle', action: 'clear' }
                )
                service.recycleBin
                  .clearRecycle(params)
                  .then(data => {
                    if (+data.code === 200) {
                      this.queryList()
                    } else if (+data.code === 270003 || +data.code === 403) {
                      this.$message.warning('无清空回收站权限！请联系项目创建人!')
                    } else {
                      this.$message.error('清空回收站失败')
                    }
                  }).catch(() => {
                    this.$message.error('清空回收站失败')
                  })
              },
              submitText: '确定清空', // 确定按钮文字 默认"确定"
              cancelText: '取消' // 取消按钮文字 默认"取消"
            })
          }
          break
        default:
      }
    },
    // 3. 判断是否有 已选择的文件
    judgeSelect () {
      let total = 0
      const files = []
      this.dataList.forEach(item => {
        if (item.checked) {
          total += 1
          files.push(item)
        }
      })
      this.select.total = total
      this.select.files = files
      let isCheckAll = this.dataList.length > 0
      this.dataList.forEach(lineData => {
        if (!lineData.checked) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
    },
    // 判断是否已经二次验证
    // async isDoubleVerify (){
    //   const userinfo = JSON.parse(getCookie('ZJYUSERINFO'))
    //   this.phone = userinfo.passwordMobile
    //   let result = await new Promise((resolve, reject) => {
    //     LoginService.isDoubleVerify(userinfo.passwordMobile).then(res => {
    //       if (res.code === 200){
    //         if (res.data){ // 需要二次验证-弹出弹框
    //           console.log('未二次验证！')
    //           this.showVerify = true
    //           resolve(true)
    //         } else { // 已经验证过
    //           console.log('二次验证已通过！')
    //           resolve(false)
    //         }
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   })
    //   return result
    // },

    // // 二次验证---确定
    // verifyConfirm (){
    //   console.log('验证成功，请继续操作！')
    // },
    // 4. 操作回收站数据 list: 操作的数据列表; type: 操作 restore(还原)、deleteThoroughly(彻底删除)
    async dealItem (list, type, isContextMenu = false, isTop) {
      // 埋点
      if (this.forSpaceEnterprise) { // 项目库
        if (isTop) { // 顶部按钮
          if (type === 'restore') {
            this.sentLog(100112047, {count: this.select.files.length})
          } else {
            this.sentLog(100112050, {count: this.select.files.length})
          }
        } else if (isContextMenu) { // 右键
          if (type === 'restore') {
            this.sentLog(100112048, {count: this.select.files.length})
          } else {
            this.sentLog(100112051, {count: this.select.files.length})
          }
        } else { // 操作列
          if (type === 'restore') {
            this.sentLog(100112049, {count: this.select.files.length})
          } else {
            this.sentLog(100112052, {count: this.select.files.length})
          }
        }
      } else if (this.tabletype === 'companyList') {
        if (type === 'restore') {
          this.sentLog(100114012)
        } else {
          this.sentLog(100114013)
        }
      } else {
        if (isTop) { // 顶部按钮
          if (type === 'restore') {
            this.sentLog(100113025, {count: this.select.files.length})
          } else {
            this.sentLog(100113028, {count: this.select.files.length})
          }
        } else if (isContextMenu) { // 右键
          if (type === 'restore') {
            this.sentLog(100113026, {count: this.select.files.length})
          } else {
            this.sentLog(100113029, {count: this.select.files.length})
          }
        } else { // 操作列
          if (type === 'restore') {
            this.sentLog(100113027, {count: this.select.files.length})
          } else {
            this.sentLog(100113030, {count: this.select.files.length})
          }
        }
      }
      // 埋点--结束
      let deleteData = []
      let newList = list
      let fileSize = 0
      const params = {}
      // if (type === 'deleteThoroughly'){
      //   if (this.tabletype !== 'projectList'){
      //     let flag = await this.isDoubleVerify()
      //     if (flag) {
      //       return false
      //     }
      //   }
      // }
      // 如果是彻底删除，先提示选择数据
      if (
        type === 'deleteThoroughly' &&
        list.length === 0 &&
        !this.select.total
      ) {
        this.$message.info('请先选择文件')
        return
      }
      // 如果是彻底删除，提示无权限
      if (
        type === 'deleteThoroughly' && this.forSpaceEnterprise && this.prjRole !== 1 && !this.isAdmin
      ) {
        this.$message.warning('无彻底删除权限！请联系项目管理者!')
        return
      }
      if (!list.length) {
        newList = this.select.files
        if (!this.select.total) {
          this.$message.info('请先选择文件')
          return
        } else {
          deleteData = this.select.files.map(file => {
            if (file.length) {
              fileSize = fileSize + file.length
            }
            return file.fileId
          })
        }
      } else {
        fileSize = list[0].length
        deleteData = [list[0].fileId]
      }
      switch (type) {
        case 'deleteThoroughly':
          // 彻底删除埋点-点击
          this.$confirm({
            message: '确定要彻底删除？',
            type: 'warning',
            tips: '文件彻底删除后，不能恢复。',
            dealData: { deleteData: deleteData, list: newList },
            submit: data => {
              this.deleteConfirm(data)
            },
            submitText: '确定删除'
          })
          break
        case 'restore':
          if (this.forSpaceEnterprise) {
            params.projectId = this.urlParams.id
          } else {
            params.workspaceId = this.workspaceId
          }
          params.fileInfo = newList.map(item => {
            return {
              folder: item.folder,
              fileId: item.fileId
            }
          })

          this.checkCapacity(fileSize)
            .then(() => {
              service.recycleBin
                .restoreRecycle(params)
                .then(data => {
                  if (+data.code === 200) {
                    // 操作记录
                    this.addOperationRecords(5, newList, { page: 'recycle' })
                    this.$message.success('还原成功')
                    this.queryList()
                  } else {
                    this.$message.error(data.message ? data.message : '还原失败')
                  }
                })
                .catch(() => {
                  this.$message.error('还原失败')
                })
            })
            .catch(() => {})
          break
        default:
      }
    },
    // 容量校验
    checkCapacity (fileSize) {
      return new Promise((resolve, reject) => {

        const TenantInfo = JSON.parse(sessionStorage.getItem('TenantInfo'))
        const categoryCodes = TenantInfo.categoryCodes
        let workspaceId, hintText
        if (categoryCodes === 'personal') {
          workspaceId = getCookie('personalWorkspaceIdValue')
          hintText = '个人空间容量不足，请您整理个人空间'
        } else {
          workspaceId = getCookie('enterpriseWorkspaceIdValue')
          hintText = '企业共享空间容量不足，请您联系管理员进行扩容'
        }
        SpaceService.getWorkspaceById({ workspaceId: workspaceId }).then(
          data => {
            if (+data.code === 200) {
              let { totalCapacity, usedCapacity } = data.data
              usedCapacity = usedCapacity || 0
              if (
                parseInt(totalCapacity) >
                parseInt(usedCapacity) + parseInt(fileSize)
              ) {
                resolve()
              } else {
                if (+this.user.role === 2) {
                  this.$confirm({
                    message: hintText,
                    width: 400,
                    multipleSubmit: [
                      { name: '购买套餐', key: 'ImportType', value: 3 },
                      { name: '确定', key: 'optType', value: 1 }
                    ],
                    noCancelBtn: true,
                    submit: ({ ImportType }) => {
                      if (+ImportType === 3) {
                        this.$router.push({
                          path: '/vip'
                        })
                      }
                    }
                  })
                } else {
                  this.$message.warning(hintText)
                }
                reject(new Error('error logs'))
              }
            }
          }
        )
      })
    },
    // 4.1 清空回收站、彻底删除 确定
    deleteConfirm (obj) {
      // console.log(list)
      // let list = obj.deleteData;
      const params = {}
      if (this.forSpaceEnterprise) {
        params.projectId = this.urlParams.id
      } else {
        params.workspaceId = this.workspaceId
      }
      params.fileInfo = obj.list.map(item => {
        return {
          folder: item.folder,
          fileId: item.fileId
        }
      })
      service.recycleBin
        .deleteRecycle(params)
        .then(data => {
          if (+data.code === 200) {
            // 操作记录
            this.addOperationRecords(3, obj.list, { page: 'recycle' })
            this.$message.success('删除成功')
            this.queryList()
          } else if (+data.code === 270003 || +data.code === 403) {
            this.$message.warning('无彻底删除权限！请联系项目管理者!')
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {
          this.$message.error('删除失败')
        })
    },
    // 5. 全选
    checkAll () {
      // this.isCheckAll = !this.isCheckAll
      let dataList = [...this.dataList]
      dataList = dataList.map(item => {
        // item.checked = !this.isCheckAll
        item.checked = this.isCheckAll
        return {
          ...item
        }
      })
      this.dataList = dataList
      // this.judgeSelect()
    },
    // 6. 某一行 复选框点击
    checkOne (item, index) {
      // this.$set(this.dataList[index], 'checked', !item.checked)
      this.judgeSelect()
    },
    // 7. table 数据 某一行鼠标 移入事件
    trMouseEnter (item, index) {
      this.eventObj.mouseInTr = true
      if (item.checked) {
        this.eventObj.trFocusIndex = index
      }
      // if (item.folder) {
      //   this.eventObj.mousedownInSelectTr = true;
      // }
    },
    // 7.1 table 数据 某一行鼠标 移出事件
    trMouseLeave () {
      this.eventObj.mouseInTr = false
      this.eventObj.trFocusIndex = -1
    },
    // 7.2 table 数据 某一行鼠标 点击事件
    trClick (index, e) {
      e.stopPropagation()
      e.preventDefault()
      let dataobj = { ...this.dataList[index] }
      this.contextMenuShow = false
      dataobj.checked = !dataobj.checked
      if (!dataobj.checked) {
        this.eventObj.mousedown = false
      }
      if (this.eventObj.shift) {
        if (this.eventObj.clickIndex === undefined) {
          return
        }
        let dataList = [...this.dataList]
        dataList = dataList.map((item, itemindex) => {
          if (this.eventObj.clickIndex >= index) {
            if (itemindex >= index && itemindex <= this.eventObj.clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          } else if (this.eventObj.clickIndex < index) {
            if (itemindex <= index && itemindex >= this.eventObj.clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          }
          return {
            ...item
          }
        })
        this.dataList = dataList
      } else {
        this.eventObj.clickIndex = index
        this.dataList.splice(index, 1, dataobj)
      }
      this.judgeSelect()
    },
    // 8. 初始化事件
    initEvent () {
      this.destroyEvent()
      // 监听 是否按着 Ctrl、Shift键
      domEvent.on(
        document,
        'keydown',
        (this.eventObj.keydownEvent = e => {
          switch (e.keyCode) {
            case 16:
              this.eventObj.shift = true
              break
            case 17:
              this.eventObj.ctrl = true
              break
            default:
          }
        })
      )
      // 设置 未按着 Ctrl、Shift键
      domEvent.on(
        document,
        'keyup',
        (this.eventObj.keyupEvent = e => {
          this.eventObj.shift = false
          this.eventObj.ctrl = false
        })
      )
      // 监听 鼠标左键 点击时 隐藏右键菜单
      domEvent.on(
        document,
        'click',
        (this.eventObj.clickEvent = e => {
          if (this.contextMenuShow) {
            this.contextMenuShow = false
          }
        })
      )
      // 添加右键菜单显示 监听
      setTimeout(() => {
        let tableContent = this.$refs.tableContent
        domEvent.on(tableContent, 'contextmenu', e => {
          if (this.eventObj.mouseInTr) {
            e = e || window.event
            e.stopPropagation()
            e.preventDefault()
            let _x = e.clientX || e.x
            let _y = e.clientY || e.y
            let contextMenuDom = document.querySelector('.contextMenu')
            contextMenuDom.style.left = _x + 10 + 'px'
            contextMenuDom.style.top = _y + 10 + 'px'
            this.contextMenuShow = true
          }
        })
      }, 200)
      // 监听 mousedown
      domEvent.on(
        document,
        'mousedown',
        (this.eventObj.mousedownEvent = e => {
          if (this.eventObj.mouseInTr) {
            this.eventObj.mousedownInSelectTr = true
            if (this.eventObj.trFocusIndex !== -1) {
              this.eventObj.mousedown = true
            }
            this.eventObj.starX = e.clientX
            this.eventObj.starY = e.clientY
          }
        })
      )
      // 监听 mousemove
      domEvent.on(
        document,
        'mousemove',
        (this.eventObj.mousemoveEvent = throttle(100, e => {
          e.stopPropagation()
          e.preventDefault()
          if (this.eventObj.mousedown) {
            // if (!this.eventObj.isAddBox && (Math.abs(e.clientX - this.eventObj.starX) > 10 ||
            //   Math.abs(e.clientY - this.eventObj.starY) > 10)){
            //   this.eventObj.isAddBox = true;
            // }
            // if (!this.eventObj.isAddBox) return;
            // //   if (USER_TYPE === 2 && spaceType) {
            // //     return;
            // //   }
            // let mydragIconDom = document.querySelector('.mydrag-icon');
            // mydragIconDom.style.left = e.clientX + 10 + 'px';
            // mydragIconDom.style.top = e.clientY + 10 + 'px';
            // this.mydragIconShow = true;

            // if (event.preventDefault) {
            //   event.preventDefault();
            // }
            return false
          } else if (this.eventObj.mousedownInSelectTr) {
            if (
              !this.eventObj.isAddBox &&
              (Math.abs(e.clientX - this.eventObj.starX) > 10 ||
                Math.abs(e.clientY - this.eventObj.starY) > 10)
            ) {
              this.eventObj.isAddBox = true
            }
            if (!this.eventObj.isAddBox) return
            if (!this.mydragSelShow) {
              this.mydragSelShow = true
              return
            }
            let _x = e.clientX || e.x
            let _y = e.clientY || e.y
            let mydragSel = document.querySelector('.mydrag-sel')
            mydragSel.style.left = Math.min(_x, this.eventObj.starX) + 'px'
            mydragSel.style.top = Math.min(_y, this.eventObj.starY) + 'px'
            mydragSel.style.width =
              Math.abs(e.clientX - this.eventObj.starX) + 'px'
            mydragSel.style.height =
              Math.abs(e.clientY - this.eventObj.starY) + 'px'

            let _l = mydragSel.offsetLeft
            let _t = mydragSel.offsetTop
            let _w = mydragSel.clientWidth
            let _h = mydragSel.clientHeight

            let tableContent = this.$refs.tableContent
            let tableBodyWrapper = document.querySelector(
              '.table-body-wrapper'
            )
            let projectTabOffSetLeft = tableContent.offsetLeft
            let projectTabOffSetTop =
              tableContent.offsetTop + 40 - tableBodyWrapper.scrollTop
            let trlist = document.querySelectorAll('.trItem')
            for (let i = 0; i < trlist.length; i++) {
              let item = trlist[i]
              let sl =
                item.clientWidth + item.offsetLeft + projectTabOffSetLeft
              let st = item.clientHeight + item.offsetTop + projectTabOffSetTop
              let dataobj = { ...this.dataList[i] }
              if (
                sl > _l &&
                st > _t &&
                item.offsetLeft + projectTabOffSetLeft < _l + _w &&
                item.offsetTop + projectTabOffSetTop < _t + _h
              ) {
                if (!dataobj.checked) {
                  dataobj.checked = true
                  this.dataList.splice(i, 1, dataobj)
                }
              } else {
                if (dataobj.checked) {
                  dataobj.checked = false
                  this.dataList.splice(i, 1, dataobj)
                }
              }
            }
          }
        }))
      )
      // 监听 mouseup
      domEvent.on(
        document,
        'mouseup',
        (this.eventObj.mouseupEvent = e => {
          this.eventObj.mousedown = false
          this.eventObj.mousedownInSelectTr = false
          this.eventObj.isAddBox = false
          this.mydragSelShow = false
          this.mydragIconShow = false
          this.judgeSelect()
        })
      )
    },
    // 8.1 销毁事件
    destroyEvent () {
      domEvent.off(document, 'keydown')
      domEvent.off(document, 'keyup')
      domEvent.off(document, 'click')
      domEvent.off(document, 'mousedown')
      domEvent.off(document, 'mousemove')
      domEvent.off(document, 'mouseup')
      this.eventObj.keydownEvent = null
      this.eventObj.keyupEvent = null
      this.eventObj.clickEvent = null
      this.eventObj.mousedownEvent = null
      this.eventObj.mousemoveEvent = null
      this.eventObj.mouseupEvent = null
    }
  },
  watch: {
    userInfoReady: function () {
      this.queryList()
    },
    workspaceReady: function () {
      this.queryList()
    }
  },
  components: {
    OperationButtons,
    OperationFileType,
    OperationModuleType,
    OperationSearch,
    SimpleTable,
    VerifyCode
  }
}

function handelTextBoxStyle (that) {
  let personTextboxAll
  if (that.queryCondition.moduleType === 'list') {
    personTextboxAll = document.querySelectorAll('.trItem')
  } else {
    personTextboxAll = document.querySelectorAll('.imgItem')
  }
  let w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  let h =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight

  let tableBodyWrapper =
    that.queryCondition.moduleType === 'list'
      ? document.querySelector('.table-body-wrapper')
      : document.querySelector('.listcnt')
  let tablieBodyScrollTop = tableBodyWrapper ? tableBodyWrapper.scrollTop : 0
  for (let i = 0; i < personTextboxAll.length; i++) {
    if (personTextboxAll[i].querySelector('.person-textbox')) {
      if (that.queryCondition.moduleType === 'list') {
        if (personTextboxAll[i].offsetTop + 500 - tablieBodyScrollTop > h) {
          personTextboxAll[i].querySelector('.person-textbox').style.top =
            'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.bottom =
            '0'
        }
      } else {
        if (personTextboxAll[i].offsetLeft + 600 > w) {
          personTextboxAll[i].querySelector('.person-textbox').style.left =
            'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.right =
            '90%'
        }
      }
    }
  }
}
</script>
<style lang="less" type="text/less">
@import "./ProjectTable/Index";
.recycle-bin {
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  &.space-enterprise {
    padding-top: 0;
  }
  .table-wrapper .table-body-wrapper {
    top: -1px;
    td {
      box-sizing: border-box;
      word-break: break-all;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .table-wrapper .table-head-wrapper {
    th {
      box-sizing: border-box;
    }
  }
  .table-wrapper .table-body-wrapper > table {
    border-top: 0;
    border-bottom: 0;
  }
  .recycle-file-name {
    max-width: calc(100% - 80px);
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    cursor: pointer;
  }
  table {
    table-layout: fixed;
    td {
      box-sizing: border-box;
    }
  }

  .imgItem-checkall {
    text-align: left;
    padding: 10px 0px;
  }
  .prj-title{
    font-size: 16px;
    font-weight: 500;
    color: #212530;
    line-height: 32px;
    margin-bottom: 16px;
    margin-top: 4px;
  }
}
.enterprise-recycle{
  .recycle-bin{
    padding-top: 0;
  }
}

</style>
